import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useToast } from '@/hooks/use-toast';
import { createFolder, createPersonalFolder } from '../api/documents';
import { createFolderErrorCodes } from '../utils/errorCodes';
import { acAddPersonalFolder } from '../store/actions/personalDocuments';
import { acAddPropertyFolder } from '../store/actions/documents';

const useAddNewDocumentMenu = ({
  currentDocFolderId,
  breadCrumbs,
  isPersonal,
  boligmappaNumber,
}) => {
  const dispatch = useDispatch();
  const { toast } = useToast();

  const [isAddingNewDoc, setIsAddingNewDoc] = useState(false);
  const [isCreatingName, setIsCreatingName] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [folderNameErrorMessage, setFolderNameErrorMessage] = useState(
    'Skriv inn mappenavn'
  );
  const [isFolderNameError, setIsFolderNameError] = useState(false);

  const onAddNewDoc = () => {
    setIsAddingNewDoc(true);
  };

  const onCancelCreatingFolder = () => {
    setIsCreatingName(false);
    setNewFolderName('');
  };

  const onFolderCreate = async () => {
    if (newFolderName.length > 0) {
      const createFolderRequest = isPersonal
        ? createPersonalFolder
        : createFolder;
      const data = {
        name: newFolderName,
        parentId: currentDocFolderId && currentDocFolderId,
      };
      const [error, response] = await createFolderRequest(
        data,
        boligmappaNumber
      );
      if (!error && response) {
        if (isPersonal) {
          dispatch(acAddPersonalFolder(breadCrumbs, response));
        } else {
          dispatch(acAddPropertyFolder(breadCrumbs, response));
        }
        setNewFolderName('');
        setIsCreatingName(false);
        setIsAddingNewDoc(false);
        toast({ title: 'Mappe opprettet', variant: 'success' });
        return true;
      }
      if (error) {
        setFolderNameErrorMessage(
          createFolderErrorCodes[error.code] || error.code
        );
        setIsFolderNameError(true);
      }
    } else {
      setFolderNameErrorMessage('Skriv inn mappenavn');
      setIsFolderNameError(true);
    }
    return false;
  };

  useEffect(() => setIsFolderNameError(false), [newFolderName, isCreatingName]);
  useEffect(() => {
    if (!isAddingNewDoc) {
      setIsCreatingName(false);
    }
  }, [isAddingNewDoc]);

  return {
    isAddingNewDoc,
    setIsAddingNewDoc,
    isCreatingName,
    setIsCreatingName,
    newFolderName,
    setNewFolderName,
    folderNameErrorMessage,
    setFolderNameErrorMessage,
    isFolderNameError,
    setIsFolderNameError,
    onAddNewDoc,
    onFolderCreate,
    onCancelCreatingFolder,
  };
};

export default useAddNewDocumentMenu;
